import LayerAnimation from './LayerAnimation.js';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { AnimationDirection } from './types.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var enterDuration = 225;
var exitDuration = 300;
var easing = 'ease-in-out';
var verticalOffset = 2;
var FullBleed = styled.div.withConfig({
  displayName: "Animations__FullBleed",
  componentId: "sc-1irsy90-0"
})(["height:100%;width:100%;position:fixed;top:0;left:0;pointer-events:none !important;> *{pointer-events:auto;}"]);

var getTransformForDirection = function getTransformForDirection(direction) {
  var horizontal = 0;
  var vertical = 0;
  var modifier = 1;
  var origin = AnimationDirection.Top;

  if (direction === AnimationDirection.Top) {
    vertical = verticalOffset;
    origin = 'bottom center';
    modifier = 1;
  }

  if (direction === 'bottom') {
    origin = 'top center';
    vertical = verticalOffset;
    modifier = -1;
  }

  if (direction === 'left') {
    origin = 'right center';
    horizontal = verticalOffset;
    modifier = 1;
  }

  if (direction === 'right') {
    origin = 'left center';
    horizontal = verticalOffset;
    modifier = -1;
  }

  return {
    transform: "translate3d(".concat(modifier * horizontal * 2, "px, ").concat(modifier * vertical * 2, "px, 0) scale(0.98)"),
    origin: origin
  };
};

var Slide = function Slide(_ref) {
  var _ref$animationOptions = _ref.animationOptions,
      animationOptions = _ref$animationOptions === void 0 ? {} : _ref$animationOptions,
      props = _objectWithoutProperties(_ref, ["animationOptions"]);

  var restingTransform = "translate3d(0px, 0px, 0) scale(1)";
  var direction = animationOptions.direction;

  var _ref2 = direction ? getTransformForDirection(direction) : {
    transform: undefined,
    origin: undefined
  },
      transform = _ref2.transform,
      origin = _ref2.origin; // const transformOrigin = `${animationOptions.direction || 'top'} center`


  return /*#__PURE__*/React.createElement(LayerAnimation, _extends({
    component: FullBleed,
    enterDuration: animationOptions.enterDuration || enterDuration,
    exitDuration: animationOptions.exitDuration || exitDuration,
    styleDefault: {
      transformOrigin: origin,
      transition: "transform ".concat(enterDuration, "ms ").concat(easing, ", opacity ").concat(enterDuration, "ms linear")
    },
    transition: {
      entering: {
        opacity: 0,
        transform: transform
      },
      entered: {
        opacity: 1,
        transform: restingTransform
      },
      exiting: {
        opacity: 0,
        transform: transform
      },
      exited: {
        opacity: 0,
        transform: transform
      }
    }
  }, props));
};
Slide.propTypes = {
  animationOptions: PropTypes.object
};
var SlideDown = function SlideDown(_ref3) {
  var _ref3$animationOption = _ref3.animationOptions,
      animationOptions = _ref3$animationOption === void 0 ? {} : _ref3$animationOption,
      props = _objectWithoutProperties(_ref3, ["animationOptions"]);

  var translateY = 0;
  var restingTransform = "translate3d(0, ".concat(translateY, "px, 0) scale(1.0)");
  return /*#__PURE__*/React.createElement(LayerAnimation, _extends({
    component: FullBleed,
    enterDuration: animationOptions.enterDuration || enterDuration,
    exitDuration: animationOptions.exitDuration || exitDuration,
    styleDefault: {
      transition: "transform ".concat(enterDuration, "ms ").concat(easing, ", opacity ").concat(enterDuration, "ms linear")
    },
    transition: {
      entering: {
        opacity: 0,
        transform: "translate3d(0, -".concat(verticalOffset * 2, "px, 0) scale(0.98)")
      },
      entered: {
        opacity: 1,
        transform: restingTransform
      },
      exiting: {
        opacity: 0,
        transform: "translate3d(0, -".concat(verticalOffset * 2, "px, 0) scale(0.98)")
      },
      exited: {
        opacity: 0,
        transform: "translate3d(0, -".concat(verticalOffset * 2, "px, 0) scale(0.98)")
      }
    }
  }, props));
};
SlideDown.propTypes = {
  animationOptions: PropTypes.object
};
var Fade = function Fade(_ref4) {
  var _ref4$animationOption = _ref4.animationOptions,
      animationOptions = _ref4$animationOption === void 0 ? {} : _ref4$animationOption,
      props = _objectWithoutProperties(_ref4, ["animationOptions"]);

  return /*#__PURE__*/React.createElement(LayerAnimation, _extends({
    enterDuration: animationOptions.enterDuration || enterDuration,
    exitDuration: animationOptions.exitDuration || exitDuration,
    styleDefault: {
      transition: "opacity ".concat(enterDuration, "ms")
    },
    transition: {
      entering: {
        opacity: 0
      },
      entered: {
        opacity: 1
      },
      exiting: {
        opacity: 0
      },
      exited: {
        opacity: 0
      }
    }
  }, props));
};
Fade.propTypes = {
  animationOptions: PropTypes.object
};
var None = function None(props) {
  return /*#__PURE__*/React.createElement(LayerAnimation, _extends({
    enterDuration: 0,
    exitDuration: 0,
    styleDefault: {},
    transition: {
      entering: {
        opacity: 0
      },
      entered: {
        opacity: 1
      },
      exiting: {
        opacity: 0
      },
      exited: {
        opacity: 0
      }
    }
  }, props));
};
var Animations = {
  None: None,
  Slide: Slide,
  SlideDown: SlideDown,
  Fade: Fade,
  Custom: 'Custom'
};

export { Animations, Fade, None, Slide, SlideDown };
